<div class="flex flex-col h-full mx-2">
	<h4 class="pl-4 mt-4">
		<app-anchor type="static" (click)="goBack()" class="inline-block"
			>Templates</app-anchor
		>
		<span class="mx-2">/</span>
		<ng-container *ngFor="let folder of breadcrumbs">
			<span [innerHtml]="folder | titlecase"></span>
			<span class="mx-2">/</span>
		</ng-container>
		{{ currentBusinessTemplate?.title }}
	</h4>
	<app-container>
		<div class="flex flex-col h-full">
			<div class="flex justify-between">
				<div class="flex flex-col">
					<div class="flex">
						<h3 class="mb-2">{{ currentBusinessTemplate?.title }}</h3>
					</div>
					<div class="mb-3 flex">
						<div class="flex">
							<p>
								<label class="font-bold">Current version:</label>
							</p>
							<app-pill class="ml-2" mode="secondary">{{
								currentViewingDocument$.getValue() | documentVersion
							}}</app-pill>
						</div>
					</div>

					<atomic-message-bar
						class="mt-2"
						type="info"
						*ngIf="showUpdateToLastestAlert"
					>
						To import the latest version,<label
							class="mx-1 text-green hover:underline cursor-pointer"
							(click)="updateToLastestDocument()"
						>
							click here</label
						></atomic-message-bar
					>
				</div>

				<div class="flex">
					<div>
						<app-button
							class="mr-2"
							size="small"
							btn="secondary"
							(click)="goBackToCurrentDocument()"
							*ngIf="selectedVersion"
							>Go to current version</app-button
						>
					</div>

					<div>
						<app-button
							(click)="saveDocument()"
							size="small"
							*ngIf="!selectedVersion"
							[disabled]="saveButtonDisabled"
							[matTooltip]="saveButtonDisabled ? 'No changes made' : ''"
							>Save changes</app-button
						>
					</div>

					<div>
						<app-button
							(click)="rollBackToOldDocument()"
							size="small"
							*ngIf="selectedVersion"
							>Roll back to this version</app-button
						>
					</div>
				</div>
			</div>

			<div class="flex h-full">
				<div class="w-9/12 h-full flex">
					<app-business-document-editor
						*ngIf="
							documentId && !selectedVersion && showEditor && savingDocument
						"
						class="flex flex-col"
						[document]="savingDocument"
						[documentHtml]="savingDocumentHtml"
						(onDocumentTitleChange)="onTitleChange($event)"
						(onDocumentHtmlChange)="onDocumentHtmlChange($event)"
						(onDocumentMarginsAndPageSizeChange)="
							onDocumentMarginsAndPageSizeChange($event)
						"
					>
					</app-business-document-editor>

					<app-business-document-editor
						*ngIf="
							documentId &&
							selectedVersion &&
							showViewer &&
							currentSelectedVersionTemplate
						"
						[disabled]="true"
						[document]="currentSelectedVersionTemplate"
						[documentHtml]="currentSelectedVersionTemplateHtml"
					>
					</app-business-document-editor>
				</div>

				<div class="ml-3 w-1/4">
					<app-container *ngIf="!selectedVersion" [@openClose]>
						<h4>Options</h4>
						<div class="w-full" *ngIf="versionsList?.length > 0">
							<hr />

							<label class="my-4 font-bold text-base">Version history</label>

							<div class="flex flex-col mt-2">
								<div
									class="flex my-2 cursor-pointer"
									*ngFor="let versionItem of versionsList | slice: 0 : 3"
									(click)="onSelectVersion(versionItem)"
								>
									<app-pill [mode]="versionItem.mode" class="mr-2">{{
										versionItem.versionItem | documentVersion
									}}</app-pill>
									<label class="text-green hover:underline cursor-pointer"
										>({{
											versionItem.versionItem.createdAt | date: 'short'
										}})</label
									>
								</div>

								<ng-container *ngIf="showAllVersion">
									<div
										[@openClose]
										class="flex my-2 cursor-pointer"
										*ngFor="let versionItem of versionsList | slice: 3"
										(click)="onSelectVersion(versionItem)"
									>
										<app-pill [mode]="versionItem.mode" class="mr-2">{{
											versionItem.versionItem | documentVersion
										}}</app-pill>
										<label class="text-green hover:underline"
											>({{
												versionItem.versionItem.createdAt | date: 'short'
											}})</label
										>
									</div>
								</ng-container>

								<div
									class="w-full flex items-start cursor-pointer"
									(click)="toggleShowAllVersions()"
									*ngIf="versionsList?.length > 3"
								>
									<label>{{
										showAllVersion ? 'Show less' : 'Show more'
									}}</label>
									<app-icon
										class="ml-2"
										[icon]="showAllVersion ? ICON.DOWN : ICON.UP"
									></app-icon>
								</div>
							</div>
						</div>

						<hr />

						<div data-intercom-target="letterhead-selection-checkbox">
							<label class="font-bold text-base">Letterhead</label>
							<app-header-selector
								*ngIf="savingDocumentHtml"
								[headerConfiguration]="savingDocument?.headerEnabled"
								(headerConfigurationChange)="onHeaderOptionsUpdate($event)"
							></app-header-selector>
						</div>

						<hr />

						<div>
							<label class="font-bold text-base">Footer</label>
							<app-footer-selector
								*ngIf="savingDocumentHtml"
								[footerConfiguration]="savingDocument?.footer"
								(footerConfigurationChange)="onFooterOptionsUpdate($event)"
							></app-footer-selector>
						</div>

						<hr />

						<div>
							<label class="font-bold text-base">Document available in</label>
							<matter-type-selector
								[disabled]="savingDocument.requiresContext"
								*ngIf="savingDocument"
								[matterTypes]="savingDocument.matterType"
								(matterTypesChange)="onMatterTypesUpdate($event)"
								[showMatterTypes]="showMatterTypes"
							></matter-type-selector>
						</div>

						<hr />

						<div>
							<label class="font-bold text-base">Behaviour</label>
							<div class="my-2">
								<app-checkbox
									type="clear"
									[ngModel]="savingDocument.alwaysExists"
									*ngIf="savingDocument"
									[disabled]="savingDocument.requiresContext"
									(ngModelChange)="onAlwaysExistUpdate($event)"
									>Add to file by default</app-checkbox
								>
							</div>
						</div>
					</app-container>

					<app-container class="h-auto mt-2" *ngIf="selectedVersion">
						<div class="flex">
							<h4>Versions</h4>
						</div>

						<div class="flex flex-col text-center">
							<div
								class="flex my-2 cursor-pointer"
								*ngFor="let versionItem of versionsList"
								(click)="onSelectVersion(versionItem)"
							>
								<app-pill [mode]="versionItem.mode" class="mr-2">{{
									versionItem.versionItem | documentVersion
								}}</app-pill>
								<label class="text-green hover:underline cursor-pointer"
									>({{
										versionItem.versionItem?.createdAt | date: 'dd, MMMM, YYYY'
									}})</label
								>
							</div>
						</div>
					</app-container>
				</div>
			</div>
		</div>
	</app-container>
</div>
